import { RISK_SET, RISK_ADDED, RISK_EDITED, RISK_DELETED } from 'src/app/redux/redux-types';
import { reduxRiskTypes } from 'src/types';

export const riskDefaultState: reduxRiskTypes.StateType = {
  riskList: [],
};

export const riskReducer = (state = riskDefaultState, action: reduxRiskTypes.ActionType): reduxRiskTypes.StateType => {
  switch (action.type) {
    case RISK_SET:
      return {
        ...state,
        riskList: action.payload,
      };
    case RISK_ADDED:
      const exists = state.riskList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        riskList: [action.payload, ...state.riskList],
      };
    case RISK_EDITED:
      const updateIndex = state.riskList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        riskList: [...state.riskList.slice(0, updateIndex), action.payload, ...state.riskList.slice(updateIndex + 1)],
      };
    case RISK_DELETED:
      return {
        ...state,
        riskList: state.riskList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
